import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { getOlympsConfig } from 'platform-components/src/components/app-factory/selectors';
import { createSelector } from 'reselect';

import { getLessonSlug } from 'common.components/lesson/selectors';
import { SPEC_COURSE_LESSON_VIEW_TABS } from 'common.components/spec-course-lesson-view/typings';
import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';

import { SpecCourseStore } from './typings';
import { getSpecCourseLessonStatus } from './utils';

const specCourseSelector = <T extends { specCourse: SpecCourseStore }>(storeState: T): SpecCourseStore =>
    storeState.specCourse;

export const getSpecCourseLessons = createSelector([specCourseSelector], (store) => store.clessons);

export const getActiveSpecCourseLessons = createSelector([getSpecCourseLessons], (clessons) => {
    return clessons.filter((clesson) => {
        const status: SPEC_COURSE_LESSON_STATUS = getSpecCourseLessonStatus(clesson.status);

        return [
            SPEC_COURSE_LESSON_STATUS.NOT_STARTED,
            SPEC_COURSE_LESSON_STATUS.IN_PROGRESS,
            SPEC_COURSE_LESSON_STATUS.WAITING_FOR_RESULTS,
        ].includes(status);
    });
});

export const getCompletedSpecCourseLessons = createSelector([getSpecCourseLessons], (clessons) => {
    return clessons.filter((clesson) => {
        const status: SPEC_COURSE_LESSON_STATUS = getSpecCourseLessonStatus(clesson.status);
        return status === SPEC_COURSE_LESSON_STATUS.FINISHED;
    });
});

export const getLessonsLoadingStatus = createSelector([specCourseSelector], (store) => store.lessonsLoadingStatus);

export const getShouldLoadLessons = createSelector(
    [getLessonsLoadingStatus],
    (status) => ![LOADING_STATUSES.LOADING, LOADING_STATUSES.ERROR].includes(status)
);

export const getInitStatus = createSelector([specCourseSelector], (store) => store.initStatus);

export const getIsSomethingLoading = createSelector(
    [getLessonsLoadingStatus, getInitStatus],
    (loadingStatus, initStatus) => loadingStatus === LOADING_STATUSES.LOADING || initStatus === LOADING_STATUSES.LOADING
);

export const getTab = createSelector([specCourseSelector], (store): SPEC_COURSE_LESSON_VIEW_TABS => store.tab);

export const getStudentsAwardsConfigs = createSelector([getOlympsConfig, getLessonSlug], (olympsConfig, slug) =>
    olympsConfig.studentsAwardsAvailableToTeacher.filter((config) => config.olympSlugs.includes(slug))
);

export const getStudentsAwardsCampaignSlugs = createSelector([getStudentsAwardsConfigs], (configs) =>
    configs.reduce((result: string[], config) => {
        const all = config?.campaigns.map((campaign) => campaign.campaignSlug) || [];
        result.push(...new Set(all));
        return result;
    }, [])
);
